import React from 'react';
import { Building2, Users, FileText } from 'lucide-react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'overview', label: 'Company Overview', icon: Building2 },
    { id: 'team-members', label: 'Team Members & Employees', icon: Users },
    { id: 'profile', label: 'Company Profile', icon: FileText },
  ];

  return (
    <div className="mb-8">
      <div className="flex space-x-1 rounded-xl bg-white p-1 shadow-sm">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 rounded-lg px-4 py-2 transition-all ${
                activeTab === tab.id
                  ? 'bg-slate-900 text-white shadow-sm'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              }`}
            >
              <Icon className="h-4 w-4" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigation;
